export var iconClose = {
  "children": [{
    "name": "path",
    "type": "element",
    "value": "",
    "attributes": {
      "fill": "currentColor",
      "d": "M18.53 17.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06 0 .75.75 0 0 1 0-1.06L10.94 12 5.47 6.53a.75.75 0 1 1 1.06-1.06L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12z"
    },
    "children": []
  }],
  "id": "icon-close",
  "viewBox": "0 0 24 24"
};